import { useEffect } from 'react';
import { loadSettings } from '../data/settings.ts';

/**
 * Ersetzt jede technische Fehlermeldung gegenueber dem Kind.
 *
 * Bewusst ohne lesbaren Text, ohne Rot und ohne Warnsymbol: der Bildschirm
 * darf nicht wie ein Fehler wirken, sonst denkt das Kind, es habe etwas
 * kaputt gemacht. Genau ein Bedienelement, damit es sich nicht verlaeuft.
 */
export function GrownUpScreen({ onRetry }: { onRetry: () => void }) {
  const settings = loadSettings();

  // Gesprochener Hinweis – Vierjaehrige verstehen Sprache, aber keine Schrift.
  useEffect(() => {
    if (!('speechSynthesis' in window)) return;
    const utterance = new SpeechSynthesisUtterance('Hol bitte Mama oder Papa.');
    utterance.lang = 'de-DE';
    utterance.rate = 0.9;
    window.speechSynthesis.speak(utterance);
    return () => window.speechSynthesis.cancel();
  }, []);

  return (
    <div className="grownup">
      <div className="grownup__photo">
        {settings.grownUpPhoto ? (
          <img src={settings.grownUpPhoto} alt="" draggable={false} />
        ) : (
          <span className="grownup__fallback" aria-hidden="true">
            👨‍👩‍👧
          </span>
        )}
        <span className="grownup__wave" aria-hidden="true">
          👋
        </span>
      </div>

      <button
        type="button"
        className="iconbutton iconbutton--retry"
        onClick={onRetry}
        aria-label="Nochmal versuchen"
      >
        <span aria-hidden="true">↻</span>
      </button>
    </div>
  );
}
